import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { getSdk, RelatedProductsQuery } from "services/datocms/generated";
import { createDatoClient } from "services/datocms";
import { Custom404 } from "@pepdirect/ui/Custom404";
import CollectionItem from "components/CollectionItem";
import st from "./404.module.scss";

export default function Custom404Page(): JSX.Element {
  const router = useRouter();
  const [relatedProducts, setRelatedProducts] = useState<
    NonNullable<RelatedProductsQuery["featuredProduct"]>["products"]
  >([]);

  useEffect(() => {
    getSdk(createDatoClient(router?.isPreview))
      .RelatedProducts()
      .then((res) => {
        setRelatedProducts(res?.featuredProduct?.products || []);
      });
  }, [router?.isPreview]);

  return (
    <div className={st.container}>
      <Custom404 loading={!relatedProducts}>
        {relatedProducts?.map((product) => (
          <CollectionItem
            key={product?.id}
            slug={product?.slug || ""}
            image={product?.productImages?.[0].url || ""}
            title={product.title || ""}
            nutritionLink={product?.nutritionLink || ""}
            flavorName={product?.flavorName || ""}
          />
        ))}
      </Custom404>
    </div>
  );
}
